import React from "react";
import { CV } from "../components/cv";
import PatrickFImg from "@/assets/images/patrick-f.png";

export default function CVPatrickFogwall() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Patrick Fogwall";
  }, []);

  return (
    <CV
      name="Patrick Fogwall"
      title="Freelance Software Engineer & Consultant"
      subtitle="E-commerce solution architecture on Optimizely and .NET — background at Knowit and Avensia"
      photo={PatrickFImg}
      summary="Highly experienced freelance software engineer and architect with over 15 years of professional experience, specializing in e-commerce solutions. I hold an MSc in Engineering from Lund University and am proficient in leading development projects from conception to delivery for a diverse range of clients, from high-street fashion to industrial wholesalers. Known for a broad technical skillset, commitment to mentoring, and consistently delivering high-quality, cloud-based software solutions. Professional developer since 2010 and freelancing since 2019."
      skills={{
        "Languages": ["C#", ".NET", "TypeScript", "JavaScript"],
        "Frontend": ["React", "Redux", "Next.js", "GraphQL", "Apollo"],
        "Backend": ["Node.js", "MS SQL Server", "MySQL", "Redis"],
        "Platforms": ["Optimizely CMS & Commerce", "inRiver PIM", "Voyado Elevate"],
        "Cloud & DevOps": ["MS Azure", "Azure DevOps", "Google Cloud Platform", "Docker", "CI/CD"],
        "Observability": ["Open Telemetry", "Application Insights"],
        "Methods": ["Solution Architecture", "E-commerce", "Technical Leadership", "Mentoring"],
      }}
      experience={[
        {
          role: "Freelance Software Engineer & Consultant",
          period: "Dec 2019 - Present",
          description:
            "Delivering end-to-end consulting, solution architecture, and development services specializing in complex e-commerce platforms and cloud environments. Focused on driving technical modernization, team mentorship, and high-quality implementation across diverse client projects.",
          highlights: [
            "Fitness24Seven (Dec 2023 – Present): Full-stack implementation and co-architecture of core platform modernization, encompassing technical specification, CI/CD setup and Azure provisioning",
            "Kjell & Company (Dec 2019 – Present): Senior full-stack consultant for omnichannel features and cloud services. Led critical platform upgrade project and designed authentication flows (BankID). Technical mentor for internal team",
            "Spar Kjøp AS (Nov 2022 – Aug 2023): Expert PIM consultant managing critical PIM alignment during large-scale ERP upgrade and e-commerce site revamp",
            "Knowit Experience (Dec 2019 – Mar 2020): Solutions architect consultant ensuring seamless project handover and technical successor onboarding",
          ],
        },
        {
          role: "Solutions Architect",
          company: "Knowit",
          period: "Oct 2016 - Dec 2019",
          description:
            "Solutions architect, tech lead, and developer in e-commerce. Responsibilities included detailing solutions, pre-sales, mentoring, configuring CI/CD pipelines, and hands-on implementation.",
          highlights: [
            "Fashion Retailer: Expert consultant during client project handover of Episerver Commerce solution",
            "Bona: Tech lead and architect during platform overhaul. Led architecture, specification, development and PIM implementation",
            "LK Group: Tech lead during platform upgrade and continuous feature implementation",
            "Ejendals: Tech lead specifying and building B2B e-commerce features on Episerver Commerce and inRiver PIM",
          ],
        },
        {
          role: "Solutions Architect & System Developer",
          company: "Avensia",
          period: "Mar 2011 - Sep 2016",
          description:
            "Progressed from .NET developer to solutions architect and tech lead, delivering enterprise-level e-commerce solutions for over 10 diverse clients. Responsible for end-to-end project design, technical implementation, and mentoring junior developers.",
          highlights: [
            "Ahlsell: Designed custom e-commerce solution for multi-country rollout with 3B SEK online revenue and 100K+ product catalog",
            "Intersport Sweden: Tech lead responsible for solution design and technical project leadership for new e-commerce platform",
            "Ocay: Implemented punch-out flow support over cXML for standardized procurement portals",
            "Fashion Retailer: Co-architected multi-market online marketplace solution based on Episerver Commerce and Mirakl",
          ],
        },
        {
          role: "Master's Thesis Worker & Web Developer",
          company: "Mashie",
          period: "Jun 2010 - Feb 2011",
          description:
            "Authored master's thesis and worked as .NET developer on web-based solution for nutrition and meal planning.",
        },
      ]}
      education={[
        {
          degree:
            "Master of Science (M.S.) in Engineering, Computer Science and Engineering",
          institution: "Lund University, The Faculty of Engineering",
          year: "2005-2011",
        },
      ]}
    />
  );
}
